<template>
  <l-layout :layout="['xs12']" bottom-space>
    <!-- TODO 添加RadioGroup，个人 or 全部-->
    <l-data-table
      :get-data-func="getItems"
      :headers="headers"
      @click:row="goDetails($event.item)"
      :filter-items="filter"
      clickable
      init-sort-by="creationTime"
      ref="dataTable"
      search-text="搜索行人"
      title-text="个人预约"
    >
      <template slot="title">
        <span class="pl-2 pr-4">个人预约</span>
        <v-radio-group v-if="isAdmin" mandatory row v-model="isSelf">
          <v-radio :value="true" label="个人"></v-radio>
          <v-radio :value="false" label="全部"></v-radio>
        </v-radio-group>
      </template>
      <!--<template slot="filter:ownerId">
        <v-autocomplete
          :items="userSelect"
          v-model="filter[2].value"
          v-on:keyup="getUsers"
          label="用户账号"
          clearable
          hide-details
          hide-selected
          item-text="loginId"
          item-value="loginId"
          prepend-icon="$vuetify.icons.person"
        >
          <template slot="no-data">
            <v-alert :value="true" color="error">
              暂无该用户信息
            </v-alert>
          </template>
          <template slot="item" slot-scope="props">
            <v-list-tile-content>
              <v-list-tile-title>
                <v-flex row align-center justify-between>
                  <span>{{props.item.name}}</span>
                </v-flex>
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <span class="grey&#45;&#45;text caption text-xs-right">{{props.item.loginId}}</span>
            </v-list-tile-action>
          </template>
        </v-autocomplete>
      </template>-->
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center" v-if="!isSelf">
          <v-btn @click="deleteItem(item)" icon :disabled="item.status==='-1'">
            <v-icon small>$vuetify.icons.delete</v-icon>
          </v-btn>
        </td>
      </template>
    </l-data-table>
    <l-fixed-btn
      @click="goNew"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
import {PERSON_ADMIN_ACTION_HEADERS, PERSON_ADMIN_HEADERS,PERSON_GROUP_ACTION_HEADERS} from '@/consts/reservation'
import {ReservationAuthority} from '../../../object'
import {PERMISSION} from '../../../consts/userAdmin'
import {time} from '../../../ladmin/utils'
export default {
  name: 'PersonPersonalReservation',
  props: ['refresh'],
  data: () => ({
    isSelf: true,
    isSelfHistory: true,
    selected: [],
    floatingButton: false,
    showHistory: false,
    // moreActions: [
    //   {
    //     event: 'delete',
    //     label: '批量删除',
    //     icon: '$vuetify.icons.deleteAll'
    //   },
    // ],
    headers: PERSON_GROUP_ACTION_HEADERS,
    userSelect:[],
    filter: [
      {
        prependIcon: '$vuetify.icons.edit',
        key: 'status',
        value: '{"r_h_status":"1"}',
        label: '是否有效',
        type: 'select',
        layout: ['xs12', 'sm4'],
        items: [
          {
            value: '',
            text: '全部'
          },
          {
            value: '{"r_h_status":"1"}',
            text: '有效'
          },
          {
            value: '{"r_h_status":"-1"}',
            text: '失效'
          }],
      },
      {
        label: '过期时间',
        layout: 'xs12, sm4',
        type: 'duration',
        key: 'expirationTime',
        value: {},
        range: true,
        f: v => {
          if (!v.startDatetime && !v.endDatetime) {
            return null
          }
          else {
            // let s = v.startDatetime + ':00' || 0
            // let e = v.endDatetime + ':00' || 9999999999999
            let s = time.toTimeStamp(v.startDatetime) || 0
            let e = time.toTimeStamp(v.endDatetime) || 9999999999999
            return [s, e]
          }
        }
      },
    ]
  }),
  computed: {
    isAdmin () {
      return this.$store.getters['login/hasPermissionOf'](PERMISSION.RESERVATION.PERSON.ADMIN)
    },
  },
  watch: {
    isSelf () {
      this.$refs.dataTable.refresh()
    },
    isSelfHistory () {
      this.$refs.dataTableHistory.refresh()
    }
  },
  methods: {
    getUserInfo(){
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    async getUsers (param) {
      let search = (param === undefined) ? '' : param.target.value + ''
      let pagination = {page: 0, rowsPerPage: 10}
      let searchParam = {
        'searchParam': {
          'loginId': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getUsers', {param: searchParam, pagination: pagination})
      if (res.data.status === 1) {
        this.userSelect = res.data.data.content
        console.log(this.userSelect)
      }
      else {
        this.userSelect = []
      }
    },
    async getItems ({pagination, sortStack, filterItems, search}) {
      let filter = [...filterItems]
      if(this.isSelf){
        filter.push({
          key:'creator',
          value:this.getUserInfo().id
        })
      }
      let {items,amount} = await this.$store.dispatch('personReservation/getPersonalReservations', {
        pagination,
        sortStack,
        filter: filter,
        search: {key: 'name', value: search},
      })
      let res = []
      for (let i in items) {
        let item = items[i]
        let j = JSON.parse(item.obgrp.rhdata) || {}
        let obj = {
          id: item.obgrp.id,
          name: item.obgrp.name,
          platePreview: item.platePreview,
          total: item.totalReg,
          host: (item.user===undefined)?"":item.user.name,
          phone: (item.user===undefined)?"":item.user.mobilePhone,
          creationTime: item.obgrp.creationTime,
          expirationTime: item.obgrp.expirationTime,
          status: j.r_h_status
        }
        //console.log(obj)
        res.push(obj)
      }
      return {items:res,amount:amount}
    },
    async getItemsHistory ({pagination, sortStack, filterItems, search}) {
      return this.$store.dispatch('personReservation/getPersonalReservationsHistory', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'plate', value: search},
        self: this.isSelfHistory
      })
    },
    goDetails (item, isHistory) {
      this.getReservationConfig()
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'PersonPersonalReservationDetails',
          params: {id: item.id},
          query: {id: item.id, status: item.status},
        })
      }
    },
    goReservationGroup () {
      this.$router.push({
        name: 'PersonReservationGroupList'
      })
    },
    goNew () {
      this.$router.push({
        name: 'PersonNewPersonalReservation'
      })
    },
    async getReservationConfig () {
      let res = await this.$store.dispatch('personReservationConfig/getReservationConfig', 'order_object')
      console.log(res.data.data)
      if (res.data.status === 1) {
        let object = new ReservationAuthority({
          name: '个人预约',
          maxVehicleAmount: 1000,
          maxStartDay: res.data.data.maxAdvDays,
          maxDurationDay: res.data.data.maxDurDays,
          presetCtrls: res.data.data.presetCtrls,
          limitAreaConfigs: res.data.data.limitAreaConfigs || []
        })
        // console.log(object)
        this.$store.commit('personReservation/setPersonalAuth', object)
      }
      else {
        this.$L.alert('error', {message: '查询预约配置失败，原因：' + res.data.msg})
      }
    },
    async deleteItem (item) {
      let {res, close} = await this.$L.confirm({title: '提示', text: '您确定要删除该预约，分组名称：' + item.name})
      if (res) {
        try {
          await this.$store.dispatch('personReservation/deleteGroups', [item])
            this.$L.alert('success', {message: '删除成功'})
            this.$refs.dataTable.refresh()
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
  },
  created () {
    this.getReservationConfig()
  },
  activated () {
    if (this.refresh) {
      this.$refs.dataTable.refresh()
    }
  }
}
</script>

<style scoped>

</style>
